import { stepSchemas, toFieldIssues, type FieldIssue, type FormStepId } from '@mapeamento/shared';
import type { DraftData } from './lib/object-path';

/**
 * Valida uma etapa com o MESMO schema usado pela API.
 * Retorna os problemas com caminhos iguais aos `data-path` dos campos.
 */
export function validateStep(stepId: FormStepId, data: DraftData): FieldIssue[] {
  const result = stepSchemas[stepId].safeParse(data[stepId] ?? {});
  return result.success ? [] : toFieldIssues(result.error, stepId);
}

/** Etapa (índice) do primeiro problema, para levar o usuário até ele. */
export function stepOfIssue(issue: FieldIssue, stepIds: readonly string[]): number {
  const index = stepIds.indexOf(issue.path.split('.')[0] ?? '');
  return index === -1 ? 0 : index;
}
